import { render, staticRenderFns } from "./ProvidePaypal.vue?vue&type=template&id=c9bc43ca"
import script from "./ProvidePaypal.vue?vue&type=script&lang=js"
export * from "./ProvidePaypal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports